var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-wrapper-provider"},[(_vm.state === 'SEND_CODE')?_c('SendCode',{attrs:{"label":_vm.$lang.forget_password},on:{"goBack":_vm.goToAuth}}):_vm._e(),(_vm.state === 'CHANGE_PASSWORD')?_c('ChangePassword'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }